/*!
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./index.css";

import * as React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";

// import services used by the applicateion

// to keep standardized services:
//    - service must be implemented as a pure function expecting at least ServiceContext argument
//    - service usualy returns an observable of the data type it provides

import Context from "lib/context";

import configureStore from "store/configureStore";
import apiConfig from "config/apiConfig";

import ConsoleLogger from "services/logging/ConsoleLogger";
import ApiDefault from "services/api/ApiDefault";

import App from "./components/App";
import ServicesContext from "services/ServicesContext";
import { getScrollbarWidth } from "lib/getScrollBarWidth";


/**
 * Setup application context
 *
 *    Context contain:
 *       - Logger
 *       - Api
 *       - AsyncApiActions
 */

 const contextData: ServicesContext = {} as any;


/**
 * Create & configure services & store them in the context to be
 * globally available to all components
 */

contextData.logger = new ConsoleLogger();
contextData.api = new ApiDefault(apiConfig);

/**
 * configure the redux store
 * context to epics
 */

const store = configureStore(contextData);

/**
 * Measure scrollbar width before anything else happens
 */
getScrollbarWidth();

// Render root
// Make sure the app context is injected to the app

ReactDOM.render(

   <React.StrictMode>
      <Provider store={store}>
         <Context.Provider value={contextData}>
            <App />
         </Context.Provider>
      </Provider>
   </React.StrictMode>

   ,document.getElementById("root")

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
